const getOperatorIsLoggingOut = (state) => {
  return state.operatorIsLoggingOut;
};

export { getOperatorIsLoggingOut };
